import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fs-12 text-gray ml-2" }
const _hoisted_2 = { class: "navbar-nav ml-auto" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-link__icon bt-icon" }
const _hoisted_5 = { class: "nav-link__label" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = {
  class: "nav-link",
  to: ""
}
const _hoisted_8 = { class: "nav-link__icon bt-icon" }
const _hoisted_9 = { class: "nav-link__label" }
const _hoisted_10 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-link" }
const _hoisted_13 = { class: "nav-link__icon bt-icon" }
const _hoisted_14 = { class: "nav-link__label" }
const _hoisted_15 = { class: "btn-stripped" }
const _hoisted_16 = { class: "btn-stripped" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_DialogReportProblem = _resolveComponent("DialogReportProblem")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _mergeProps(_ctx.$attrs, { class: "navbar navbar--main navbar-expand-lg" }), [
      _createVNode(_component_router_link, {
        class: "navbar-brand text-uppercase",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_InlineSvgScoped, {
            src: require(`@/assets/images/logo.svg`),
            class: "mr-2"
          }, null, 8, ["src"]),
          _createVNode(_component_InlineSvgScoped, {
            src: require(`@/assets/images/logo-text-min.svg`)
          }, null, 8, ["src"]),
          _createVNode("small", _hoisted_1, _toDisplayString(_ctx.version), 1)
        ]),
        _: 1
      }),
      _createVNode("ul", _hoisted_2, [
        _createVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'page-plants-list' }
          }, {
            default: _withCtx(() => [
              _createVNode("span", _hoisted_4, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                require(`@/assets/images/icons/icon-plants.svg`)
                            ,
                  "aria-label": "icon-plants"
                }, null, 8, ["src"])
              ]),
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.Plants")), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_6, [
          _createVNode(_component_ElDropdown, {
            trigger: "click",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"240px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElDropdownItem, null, {
                    default: _withCtx(() => [
                      _createVNode("button", {
                        class: "btn-stripped d-flex align-items-center",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleReportProblemDialog && _ctx.toggleReportProblemDialog(...args)))
                      }, [
                        _createVNode("span", _hoisted_10, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                require('@/assets/images/icons/icon-mail.svg')
                                            ,
                            "aria-label": "icon-report_a_problem"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.ReportaProblem")), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", _hoisted_8, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                    require(`@/assets/images/icons/icon-setting.svg`)
                                ,
                    "aria-label": "icon-setting"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.Settings")), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_11, [
          _createVNode(_component_ElDropdown, { trigger: "click" }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, null, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ElDropdownItem, {
                    onClick: _withModifiers(_ctx.toggleDialogProfile, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_15, _toDisplayString(_ctx.$t("AppResource.Profile")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, _ctx.profilePageEnabled]
                  ]),
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _withModifiers(_ctx.logout, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_16, _toDisplayString(_ctx.$t("AppResource.SignOut")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_12, [
                _createVNode("span", _hoisted_13, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                    require(`@/assets/images/icons/icon-profile.svg`)
                                
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.Profile")), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ], 16),
    _createVNode(_component_DialogReportProblem, {
      "is-visible": _ctx.isVisibleDialogReportProblem,
      onHideDialog: _ctx.toggleReportProblemDialog
    }, null, 8, ["is-visible", "onHideDialog"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isVisibleDialogProfile,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isVisibleDialogProfile = $event)),
      header: _ctx.$t('AppResource.Profile'),
      modal: ""
    }, {
      default: _withCtx(() => [
        _createVNode("iframe", {
          height: "800",
          width: "800",
          src: _ctx.iframeProfileSrc
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}